import React from "react";
import { Chip } from "@mui/material";

export const StatusSelectRender = ({ label, flow = "grey" }) => {
  const sx = { fontSize: 10, fontWeight: 500 };
  const props = { label, flow, sx };
  return <Chip variant="colorTag" {...props} />;
};

export const statusRenderValue = (value, options) => {
  const op = options?.find((o) => o.id === value);
  return <StatusSelectRender {...op} />;
};
